import moment from "moment";
import Vue from 'vue';

Vue.filter('data', function (value, empty = '-') {
  return !value ? empty : moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
});
